'use client';

import styled from 'styled-components';
import { colors } from '@/styles';

export const EvaluationWizard = styled.div`
  /* display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px; */
  /* border: 1px solid lime; */
  /* padding: 25px; */
`;

export const SplitFormWrapper = styled.div`
  border: 1px solid ${colors.secondary.lightGray3};
  border-radius: 5px;
  position: relative;
  display: flex;
  /* gap: 25px; */

  .prompt-input {
    background-color: white;
  }

  /* TODO: Super hacky */
  & label {
    font-weight: 600;
    .oxen-select,
    .input-hint {
      font-weight: normal;
    }
  }

  & > * {
    padding: 20px;
  }

  .collapse-icon {
    position: absolute;
    display: inline-block;
    height: 26px;
    width: 26px;
    top: 5px;
    right: 5px;
    z-index: 100;
    cursor: pointer;
    border-radius: 5px;
    &:hover {
      background-color: ${colors.secondary.lightGray2};
      border: 1px solid ${colors.secondary.lightGray3};
    }
  }

  & > * {
    background-color: ${colors.secondary.lightGray1};
  }

  & > *:nth-child(2) {
    flex: 1;
  }

  & > *:first-child,
  & > *:nth-child(3) {
    flex: 0;
    background-color: ${colors.primary.white};
    flex-basis: fit-content;
  }
  & > *:first-child {
    border-right: 1px solid ${colors.secondary.lightGray3};
    min-width: 330px;
    max-width: 360px;
    border-radius: 5px 0 0 5px;
  }
  & > *:nth-child(3) {
    border-left: 1px solid ${colors.secondary.lightGray3};
    min-width: 220px;
  }
  & > *:last-child {
    border-radius: 0 5px 5px 0;
  }
`;
